import { NavStateHandler } from "@amzn/aac-chrome-internal-api";

export const getAjaxAccountInfo = async () => {
  // add some delay to simulate what may happen in prod
  if (process.env.NODE_ENV === "development") {
    await sleep(2000);
  }
  try {
    const navState = await NavStateHandler.getInstance().getNavState();
    return navState.accountInfo;
  } catch (e) {
    window.location.replace("/500");
  }
};

const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
